var _excluded = ["id", "onOpen", "onClose", "text", "children", "className", "hasPortal", "position", "isActive", "title", "size", "hasCloseButton", "layoutContainer", "isInverse", "portalClassName", "portalId", "hasIcon", "shape", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import nodeOfType from '../../utilities/types-of-node';
import debounce from 'lodash/debounce';
import generateID from './../../utilities/generateID';
import Portal from './../../components/portal';
import Icon from '../icon';
import Type from '../type';
import Flex from '../flex';
import InverseContext from '../../utilities/inverse-context';
import StyledTooltipCloseButton from './styles/tooltip.close.button.styles';
import StyledTooltipButton from './styles/tooltip.button.styles';
import StyledTooltipBody from './styles/tooltip.body.styles';
import StyledTooltip from './tooltip.styles';
import { StyledCacheWrapper } from '../../styles';
var tooltipPropTypes = {
  /**
   * Add Tooltip Content.
   */
  children: PropTypes.node,
  /**
   * Specify the tooltip's text.
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Control the tooltips active state.
   */
  isActive: PropTypes.bool,
  /**
   * Create the Popover in a portal
   */
  hasPortal: PropTypes.bool,
  /**
   * Set tooltip position.
   */
  position: PropTypes.oneOf(['top', 'bottom']),
  /**
   * Add custom CSS classes to component.
   */
  className: PropTypes.string,
  /**
   * Adds a title to the top of the tooltip.
   */
  title: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /**
   * Tooltip size
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Renders close button to the right of text inside tooltip */
  hasCloseButton: PropTypes.bool,
  /**
   * onOpen Callback
   */
  onOpen: PropTypes.func,
  /**
   * onClose Callback
   */
  onClose: PropTypes.func,
  /**
   * Sets the id parameter of the element.
   */
  id: PropTypes.string,
  /**
   *  Container node selector or element. Defaults to body. Ideally, container should be the main scrollable area which the trigger or context lives in
   */
  layoutContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Component design with dark background.
   */
  isInverse: PropTypes.bool,
  /** Add custom CSS classes to Portal Container. */
  portalClassName: PropTypes.string,
  /** Sets the id parameter of the Portal container. */
  portalId: PropTypes.string,
  /**
   * Tooltip has an icon.
   */
  hasIcon: PropTypes.bool,
  /** Tooltip Button Shape. */
  shape: PropTypes.oneOf(['round', 'square']),
  /** Add utility props for styling */
  utils: PropTypes.object
};
var tooltipDefaultProps = {
  id: '',
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  position: 'top',
  title: '',
  className: '',
  hasPortal: false,
  isActive: false,
  size: 'md',
  hasCloseButton: false,
  layoutContainer: null,
  isInverse: false,
  portalClassName: '',
  portalId: '',
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  hasIcon: true,
  shape: 'square',
  utils: {}
};

/**
 * @ignore @description
 * ## Tooltip Component
 * Tooltips are useful for displaying short help information up to 220 characters long.
 *
 * @ignore @see Mesh: [Tooltip Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/informational-tooltip--default)
 *
 * @ignore @example
 * ```jsx
 * import { Icon, Tooltip } from "mesh-component-library";

 * <Tooltip text="Tooltip Text">
 *   <Icon
 *     icon="info-circle"
 *     size={2}
 *   />
 * </Tooltip>;
 * ```
 */

function getTransformedParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent);
    if (computedStyle.getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }
  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
}
function toggleCallbacks(active, onOpen, onClose) {
  if (active) {
    onOpen();
  } else {
    onClose();
  }
}
function scrollHandler(active, scrollToggle) {
  if (active) {
    window.addEventListener('scroll', scrollToggle, true);
  } else {
    window.removeEventListener('scroll', scrollToggle, true);
  }
}
function responsiveHandler(active, reposition, forceUpdate) {
  if (active) {
    forceUpdate();
    window.addEventListener('resize', reposition);
  } else {
    window.removeEventListener('resize', reposition);
  }
}
function documentClickHandler(active, documentClick) {
  if (active) {
    document.addEventListener('mouseup', documentClick);
  } else {
    document.removeEventListener('mouseup', documentClick);
  }
}
export function isVisible(top, left, height, width) {
  return {
    top: top > 0 ? true : top,
    bottom: top + height < window.innerHeight ? true : top + height - window.innerHeight,
    left: left > 0 ? true : left,
    right: left + width < window.innerWidth ? true : left + width - window.innerWidth + 16
  };
}
function adjustPosition(visible, position, bottom, top, triggerLeft) {
  if (position === 'bottom') {
    var adjustment = visible.bottom === true ? 'bottom' : 'top';
    return {
      adjusted: adjustment,
      y: adjustment === 'bottom' ? bottom : top,
      x: visible.right !== true ? triggerLeft - visible.right : triggerLeft - 4
    };
  } else {
    var _adjustment = visible.top === true ? 'top' : 'bottom';
    return {
      adjusted: _adjustment,
      y: _adjustment === 'top' ? top : bottom,
      x: visible.right !== true ? triggerLeft - visible.right : triggerLeft - 4
    };
  }
}
export function getPosition(tooltipRef, triggerRef, position) {
  var toolTipOffset = 16;
  if (!tooltipRef.current || !triggerRef.current) {
    return {};
  }
  var _triggerRef$current$g = triggerRef.current.getBoundingClientRect(),
    triggerTop = _triggerRef$current$g.top,
    triggerLeft = _triggerRef$current$g.left,
    triggerHeight = _triggerRef$current$g.height;
  var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
    tooltipWidth = _tooltipRef$current$g.width,
    tooltipHeight = _tooltipRef$current$g.height;
  var top = triggerTop - (tooltipHeight + toolTipOffset);
  var bottom = triggerTop + triggerHeight + toolTipOffset;
  var visible = isVisible(position === 'bottom' ? bottom : top, triggerLeft, tooltipHeight, tooltipWidth);
  var _adjustPosition = adjustPosition(visible, position, bottom, top, triggerLeft),
    y = _adjustPosition.y,
    x = _adjustPosition.x;
  var transformedParent = getTransformedParent(tooltipRef.current);
  return {
    visible: visible,
    leftAdjusted: visible.right !== true ? "".concat(visible.right - 4, "px") : 0,
    top: "".concat(y - transformedParent.parentTop, "px"),
    left: "".concat(x - transformedParent.parentLeft, "px")
  };
}
var Tooltip = function Tooltip(props) {
  var id = props.id,
    onOpen = props.onOpen,
    onClose = props.onClose,
    text = props.text,
    children = props.children,
    className = props.className,
    hasPortal = props.hasPortal,
    position = props.position,
    isActive = props.isActive,
    title = props.title,
    size = props.size,
    hasCloseButton = props.hasCloseButton,
    layoutContainer = props.layoutContainer,
    isInverse = props.isInverse,
    portalClassName = props.portalClassName,
    portalId = props.portalId,
    hasIcon = props.hasIcon,
    shape = props.shape,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var tooltipRef = useRef();
  var triggerRef = useRef();
  var useId = id || generateID('tooltip_');
  var tooltipContainerId = portalId || generateID('tooltip_container_');
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    forceUpdate = _useState2[1];
  var _useState3 = useState(isActive),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var _useState5 = useState(isActive),
    _useState6 = _slicedToArray(_useState5, 2),
    positioning = _useState6[0],
    setPostioning = _useState6[1];
  var useIsInverse = React.useContext(InverseContext);
  if (isInverse !== 'auto') {
    useIsInverse = isInverse;
  }
  useEffect(function () {
    var resizeDebounce = function resizeDebounce() {
      setPostioning(getPosition(tooltipRef, triggerRef, position));
    };
    var scrollDebounce = function scrollDebounce() {
      setActive(false);
    };
    var reposition = debounce(resizeDebounce, 200);
    var removeWithScroll = debounce(scrollDebounce, 200);
    var documentClick = function documentClick(event) {
      if (triggerRef && !triggerRef.current.contains(event.target)) {
        setActive(false);
      }
    };
    responsiveHandler(active, reposition, forceUpdate);
    scrollHandler(active, removeWithScroll);
    documentClickHandler(active, documentClick);
    toggleCallbacks(active, onOpen, onClose);
    setPostioning(getPosition(tooltipRef, triggerRef, position));
    return function () {
      window.removeEventListener('resize', reposition);
      window.removeEventListener('scroll', removeWithScroll, true);
      document.removeEventListener('mouseup', documentClick);
    };
  }, [active]);
  var toggleTooltip = function toggleTooltip(e) {
    var type = e.type;
    e.preventDefault();
    if (type === 'mousedown') {
      setActive(!active);
    }
    if (type === 'blur') {
      setActive(false);
    }
    if (type === 'focus') {
      setActive(true);
    }
  };
  var left = positioning.left,
    top = positioning.top;
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledTooltip, {
    id: tooltipContainerId,
    utils: utils,
    className: className
  }, /*#__PURE__*/React.createElement(StyledTooltipButton, _extends({
    ref: triggerRef,
    type: "button",
    "aria-describedby": useId,
    onMouseDown: toggleTooltip,
    onFocus: toggleTooltip,
    onBlur: toggleTooltip,
    hasIcon: hasIcon,
    shape: shape
  }, other), children), /*#__PURE__*/React.createElement(Portal, {
    containerClass: "c-portal-tooltip ".concat(portalClassName),
    container: layoutContainer,
    hasPortal: hasPortal
  }, /*#__PURE__*/React.createElement(StyledTooltipBody, {
    ref: tooltipRef,
    id: useId,
    style: {
      left: left,
      top: top
    },
    role: "tooltip",
    "aria-hidden": !active,
    isActive: active,
    size: size,
    position: position,
    isInverse: useIsInverse
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "between",
    alignItems: "middle"
  }, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Type, {
    element: "h6",
    weight: "bold",
    isInverse: !useIsInverse,
    utils: {
      vrTop: 'xs'
    }
  }, title), /*#__PURE__*/React.createElement(Type, {
    isInverse: !isInverse,
    utils: {
      vrTop: 'xs',
      vrRight: 'xs'
    }
  }, text)), hasCloseButton && /*#__PURE__*/React.createElement(StyledTooltipCloseButton, {
    utils: {
      alignSelf: 'top'
    },
    type: "button",
    isInverse: !isInverse,
    "aria-label": "Close Tooltip",
    isHollow: true,
    isPrimary: true,
    hasIconOnly: true
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    size: 1,
    alt: "Close"
  })))))));
};
Tooltip.defaultProps = tooltipDefaultProps;
Tooltip.propTypes = tooltipPropTypes;
export default Tooltip;